<script lang="ts">
    import { getModalStore } from '@skeletonlabs/skeleton';
    import { browser } from '$app/environment';
    import { showToast } from '$lib/helpers/toastrHelper';
    import Button from '$lib/components/common/button/Button.svelte';

    const modalStore = getModalStore();

    const responseData = $modalStore[0].files.responseData;
    const success = $modalStore[0].files.success;
    const title = $modalStore[0].files.title || 'Exported File List';

    function handleClose() {
    modalStore.close();
    }

    function getDisplayData() {
    if (success && responseData) {
      return responseData;
    }
    return responseData;
  }


</script>

<div class="card w-modal max-w-4xl p-6 space-y-4" data-testid="modal" role="dialog" aria-modal="true">
  <!-- Header -->
  <header class="flex justify-between items-center">
    <h3 class="text-lg font-bold">{title}</h3>
  </header>

  <!-- Body -->
  <section class="space-y-4">
    {#if success}
      <div class="rounded-lg bg-green-50 border border-green-200 p-4">
        <div class="flex items-center mb-2">
          <div class="w-4 h-4 rounded-full bg-green-500 mr-2"></div>
          <span class="text-green-800 font-medium">Exported Files Retrieved Successfully</span>
        </div>
      </div>
    {:else}
      <div class="rounded-lg bg-red-50 border border-red-200 p-4">
        <div class="flex items-center mb-2">
          <div class="w-4 h-4 rounded-full bg-red-500 mr-2"></div>
          <span class="text-red-800 font-medium">Failed to Retrieve Exported Files</span>
        </div>
      </div>
    {/if}

    <!-- Response Data -->
    <div class="space-y-6">
      <div class="block text-sm font-medium text-gray-700">
        {success ? 'Retrieved Exported Files:' : 'Error Details:'}
      </div>

      <div class="bg-gray-50 border rounded-lg p-4 max-h-96 overflow-auto">
        {#if success}
          <pre class="text-xs whitespace-pre-wrap text-gray-800 font-mono">
            {#if responseData?.data}
              <div class="overflow-x-auto max-h-128 overflow-y-auto">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Modified</th>
                      <th>Size</th>
                      <th>Invoice Id</th>
                      <th>Invoice Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each responseData?.data as record}
                      <tr>
                        <td>{record.name}</td>
                        <td>{record.modified}</td>
                        <td>{record.size}</td>
                        <td>{record.invoiceId}</td>
                        <td>{record.invoiceNumber}</td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            {/if}
          </pre>
        {:else}
          <pre class="text-xs whitespace-pre-wrap text-gray-800">{JSON.stringify(getDisplayData(), null, 2)}</pre>
        {/if}
      </div>

    </div>
  </section>

  <!-- Footer -->
  <footer class="flex justify-end">
    <Button
      label="Close"
      colour="primary"
      size="medium"
      onClick={handleClose}
    />
  </footer>
</div>
